export function hasRoleByName(roles, roleNames) {
  const names = Array.isArray(roleNames) ? roleNames : [roleNames];
  return (roles || []).some(role => names.includes(role.RoleName));
}
